import { apiBaseUrl } from 'APIs';
import { socket } from 'app/socket';
import axios, { AxiosRequestConfig } from 'axios';
import { ACCESS_TOKEN } from 'constant';
import Backstage from 'interfaces/Backstage.interface';
import {
  CreateNotification,
  NotificationType,
} from 'interfaces/Notification.interface';

export const getAllBackstage = async () => {
  const config: AxiosRequestConfig<any> = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
    },
  };
  const url = `${apiBaseUrl}backstage/`;
  try {
    const res = await axios.get<Backstage[]>(url, config);
    if (res.status === 200) {
      return res.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const getUsersBackstage = async () => {
  const config: AxiosRequestConfig<any> = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
    },
  };
  const url = `${apiBaseUrl}backstage/me/`;
  try {
    const res = await axios.get<Backstage[]>(url, config);
    if (res.status === 200) {
      return res.data;
    }
  } catch (error) {
    console.log('error', error);
  }
};

export const getBackstageByUsername = async (username: string) => {
  const config: AxiosRequestConfig<any> = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
    },
  };
  const url = `${apiBaseUrl}backstage/${username}/`;
  try {
    const res = await axios.get<Backstage[]>(url, config);
    if (res.status === 200) {
      return res.data;
    }
  } catch (error) {
    console.log('error', error);
  }
};

export const searchedBackstages = async (query: string) => {
  const url = `${apiBaseUrl}backstage/search/backstages?query=${query}`;
  return await axios.get(url);
};

export const postBackstage = async (
  data: Partial<Backstage>,
  approve?: boolean
) => {
  const config: AxiosRequestConfig<any> = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
    },
  };
  const url = `${apiBaseUrl}backstage/${approve ? 'approve' : ''}`;
  try {
    const res = await axios.post(url, data, config);
    if (res.status === 201) {
      return res.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const patchBackstage = async (id: number, data: Partial<Backstage>) => {
  const config: AxiosRequestConfig<any> = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
    },
  };
  const url = `${apiBaseUrl}backstage/${id}`;
  try {
    const res = await axios.patch<{ id: number }>(url, data, config);
    if (res.status === 202) {
      return res.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const lockBackstage = async (ids: number[], price: string) => {
  const config: AxiosRequestConfig<any> = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
    },
  };
  const url = `${apiBaseUrl}backstage/content/lock-multiple`;
  try {
    const res = await axios.patch<{ id: number }>(url, { ids, price }, config);
    if (res.status === 202) {
      return res.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const deleteBackstage = async (id: string) => {
  const config: AxiosRequestConfig<any> = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
    },
  };
  const url = `${apiBaseUrl}backstage/${id}`;
  try {
    const res = await axios.delete<{ id: number }>(url, config);
    if (res.status === 202) {
      return res.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const toggleLikeBackstage = async (
  id: number,
  senderId?: number,
  ownerId?: number
) => {
  const config: AxiosRequestConfig<any> = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
    },
  };
  const url = `${apiBaseUrl}backstage/like/${id}`;
  try {
    const res = await axios.patch<Backstage>(url, {}, config);
    if (res.status === 200 && ownerId && senderId && socket) {
      const likeNotificationBackstage: CreateNotification = {
        fromId: senderId,
        toId: ownerId,
        notificationType: NotificationType.LIKE,
        backstageId: id,
      };
      ownerId && socket.emit('notification', likeNotificationBackstage);
      return res.data;
    }
  } catch (error) {
    console.log(error);
  }
};
